export default "__VITE_ASSET__JfwiceOL__"